
const TOGGLE_SELECTOR = '[data-brochure-modal-open]';
const MODAL_SELECTOR = '[data-brochure-modal]';
const CLOSE_SELECTOR = '[data-brochure-modal-close]';
const BLOCK_SELECTOR = '.wp-block-ssm-ranch-buttons';

const setModalVisibility = (modal, isOpen) => {
    if (!modal) return;

    modal.classList.toggle('hidden', !isOpen);
    modal.classList.toggle('flex', isOpen);
    modal.setAttribute('aria-hidden', String(!isOpen));

    if (isOpen) {
        const dialog = modal.querySelector('[role="dialog"]');
        const closeBtn = modal.querySelector(CLOSE_SELECTOR);
        (dialog || closeBtn || modal).focus({ preventScroll: true });
    }
};

const getModalById = (id) => document.body.querySelector(`[data-brochure-modal="${id}"]`);

export const setupRanchBrochureModals = (block) => {
    const modals = Array.from(block.querySelectorAll(MODAL_SELECTOR));
    const toggles = block.querySelectorAll(TOGGLE_SELECTOR);

    if (!modals.length || !toggles.length) return;

    modals.forEach((modal) => document.body.appendChild(modal));

    const openModal = (id) => setModalVisibility(getModalById(id), true);
    const closeModal = (id) => setModalVisibility(getModalById(id), false);

    toggles.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            openModal(btn.dataset.brochureModalOpen);
        });
    });

    modals.forEach((modal) => {
        modal.querySelectorAll(CLOSE_SELECTOR).forEach((btn) => {
            btn.addEventListener('click', () => closeModal(modal.dataset.brochureModal));
        });

        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                closeModal(modal.dataset.brochureModal);
            }
        });

        modal.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                closeModal(modal.dataset.brochureModal);
            }
        });
    });
};

export function initRanchBrochureModal() {
    document.querySelectorAll(BLOCK_SELECTOR).forEach((block) => {
        setupRanchBrochureModals(block);
    });
}
